var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookGreybg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dictionary_Marketplace",
    "data-name": "Dictionary Marketplace",
    transform: "translate(-1117.865 -162.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15090",
    "data-name": "Rectangle 15090",
    width: 52,
    height: 52,
    transform: "translate(1117.865 162.549)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-book",
    transform: "translate(1130.181 175.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30588",
    "data-name": "Path 30588",
    d: "M23.158,22.842H7.421a3.421,3.421,0,1,1,0-6.842H23.158v2H7.421a1.421,1.421,0,1,0,0,2.842H23.158Z",
    transform: "translate(0.211 3.158)",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30589",
    "data-name": "Path 30589",
    d: "M6.421,2A2.421,2.421,0,0,0,4,4.421V22.579a2.42,2.42,0,0,1,2.421-2.421H23.368V2ZM19.737,9.263H10.053V6.842h9.684Z",
    fill: "#533ffb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookGreybg);
export default __webpack_public_path__ + "static/media/book-greybg.4b191bc11807493274fa8a9418fa6965.svg";
export { ForwardRef as ReactComponent };